<template>
    <div>
        <div class="container-fluid p-0 overflow-hidden cover">
            <div class="row">
                <div class="col-lg-3">
                    <b-sidebar visible no-header width="500px" shadow>
                        <template v-slot:footer>
                            <div>
                                <div class="d-flex row" v-if="firstLevel">
                                    <div class="col-lg-12">
                                        <b-list-group horizontal>
                                            <b-list-group-item
                                                style="width: 500px; cursor: pointer"
                                                v-on:click="ReturnToCreation"
                                                ><div
                                                    class="row justify-content-center"
                                                >
                                                    <b-icon-arrow-left-circle-fill
                                                        font-scale="3"
                                                        :style="{
                                                            color: colorButton
                                                        }"
                                                    ></b-icon-arrow-left-circle-fill>
                                                    <h5 class="centerTitle">
                                                        Retour à la création
                                                    </h5>
                                                </div></b-list-group-item
                                            >
                                        </b-list-group>
                                    </div>
                                </div>
                                <div
                                    class="d-flex row"
                                    v-if="firstLevel == false"
                                >
                                    <div class="col-lg-12">
                                        <b-list-group horizontal>
                                            <b-list-group-item
                                                style="width: 250px; cursor: pointer"
                                                v-on:click="ReturnHome"
                                                ><div
                                                    class="row justify-content-center"
                                                >
                                                    <b-iconstack font-scale="3"
                                                        ><b-icon
                                                            stacked
                                                            icon="circle-fill"
                                                            :style="{
                                                                color: colorButton
                                                            }"
                                                            scale="1"
                                                        ></b-icon
                                                        ><b-icon
                                                            stacked
                                                            icon="house-door"
                                                            style="color: white"
                                                            scale="0.60"
                                                        ></b-icon
                                                    ></b-iconstack>
                                                    <h5 class="centerTitle">
                                                        Accueil
                                                    </h5>
                                                </div></b-list-group-item
                                            >
                                            <b-list-group-item
                                                style="width: 250px; cursor: pointer"
                                                v-on:click="ReturnToParent"
                                                ><div
                                                    class="row justify-content-center"
                                                >
                                                    <b-icon-arrow-left-circle-fill
                                                        font-scale="3"
                                                        :style="{
                                                            color: colorButton
                                                        }"
                                                    ></b-icon-arrow-left-circle-fill>
                                                    <h5 class="centerTitle">
                                                        Retour
                                                    </h5>
                                                </div></b-list-group-item
                                            >
                                        </b-list-group>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="firstLevel === true">
                            <div>
                                <img
                                    src="/img/Header - ACCUEIL_big.png"
                                    class="img-fluid"
                                />
                            </div>
                            <div class="container align-items-center">
                                <br />
                                <div
                                    v-for="menu in arboCurrent"
                                    :key="menu.name"
                                    class="col-lg-12 align-self-center"
                                >
                                    <div class="row justify-content-center">
                                        <b-button
                                            v-on:click="moveToChild(menu, true)"
                                            size="lg"
                                            :style="{
                                                'background-color':
                                                    menu.iconcolor,
                                                border: 'none'
                                            }"
                                            pill
                                            >{{ menu.name }}</b-button
                                        >
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div v-if="firstLevel === false">
                            <div>
                                <img
                                    src="/img/Header - ACCUEIL.png"
                                    class="img-fluid image_top"
                                />
                            </div>
                            <b-list-group>
                                <b-list-group-item
                                    :style="{
                                        'background-color': parent.iconcolor,
                                        color: 'white',
                                        cursor: 'pointer'
                                    }"
                                    v-for="(parent, index) in arboParents"
                                    :key="parent.name"
                                    v-on:click="goToParent(index)"
                                    ><div class="row">
                                        <div>
                                            <img
                                                :src="
                                                    '/img/icon/' +
                                                        parent.icon +
                                                        '.svg'
                                                "
                                                class="imageParent"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="centerTitle">
                                                {{ parent.name }}
                                            </h4>
                                        </div>
                                    </div></b-list-group-item
                                >
                                <b-list-group-item
                                    v-for="(menu, index) in arboCurrent"
                                    :key="index"
                                    v-on:click="moveToChild(menu, false)"
                                    style="cursor: pointer"
                                    ><div class="row">
                                        <div>
                                            <canvasIcon
                                                class="iconImage"
                                                :pinColor="
                                                    iconData[index].color
                                                "
                                                :icon="iconData[index].icon"
                                                :index="iconData[index].index"
                                            />
                                        </div>
                                        <div>
                                            <p class="text-center center">
                                                {{ menu.name }}
                                            </p>
                                        </div>
                                    </div></b-list-group-item
                                >
                            </b-list-group>
                        </div>
                    </b-sidebar>
                </div>
                <div class="col-lg-9">
                    <canvasPins :elements="pinData" @pin-click="pinClick" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import canvasIcon from "./IconPaper.vue";
import canvasPins from "./CanvasPin.vue";

export default {
    name: "Preview",
    data: function() {
        return {
            menu: [],
            arboParents: [],
            arboCurrent: [],
            firstLevel: true,
            colorButton: "#52b948",
            pinData: [],
            iconData: [],
            test: 0
        };
    },
    components: {
        canvasIcon,
        canvasPins
    },
    async beforeMount() {
        let data = this.$route.params.menu;

        this.menu = data.list;
        this.arboCurrent = this.menu;
        this.changePin();
        this.changeIcon();
    },
    methods: {
        moveToChild: function(menuEnfant, level) {
            if (level == true) {
                this.firstLevel = false;
            }

            this.arboParents.push(menuEnfant);
            this.colorButton = menuEnfant.iconcolor;
            this.arboCurrent = menuEnfant.children;

            this.changePin();
            this.changeIcon();
        },

        goToParent: function(index) {
            if (index > 0) {
                this.arboCurrent = this.arboParents[index - 1].children;
                this.colorButton = this.arboParents[index - 1].iconcolor;
            } else {
                this.arboCurrent = this.menu;
                this.colorButton = "#52b948";
                this.firstLevel = true;
            }
            let i1 = this.arboParents.length - index;
            this.arboParents.splice(index, i1);
            this.changePin();
            this.changeIcon();
        },
        ReturnHome: function() {
            this.arboCurrent = this.menu;
            this.arboParents = [];
            this.firstLevel = true;
            this.colorButton = "#52b948";
            this.changeIcon();
            this.changePin();
        },
        ReturnToParent: function() {
            if (this.arboParents.length > 1) {
                this.arboCurrent = this.arboParents[
                    this.arboParents.length - 2
                ].children;
                this.colorButton = this.arboParents[
                    this.arboParents.length - 2
                ].iconcolor;
            } else {
                this.arboCurrent = this.menu;
                this.colorButton = "#52b948";
                this.firstLevel = true;
            }
            this.changePin();
            this.changeIcon();
            this.arboParents.pop();
        },
        ReturnToCreation: function() {
            this.$router.push({
                name: "HomeRetour",
                params: {
                    menu: this.$route.params.menu
                }
            });
        },
        changePin: function() {
            this.pinData = [];
            if (this.arboCurrent.length > 0) {
                this.arboCurrent.forEach((element, index) => {
                    this.pinData.push({
                        index: index,
                        color: element.iconcolor,
                        icon: element.icon
                    });
                });
            } else {
                for (let i = 0; i < 5; i++) {
                    this.pinData.push({
                        index: i,
                        color: this.arboParents[this.arboParents.length - 1]
                            .iconcolor,
                        icon: this.arboParents[this.arboParents.length - 1].icon
                    });
                }
            }
            console.log("pin", this.pinData);
        },
        changeIcon: function() {
            this.iconData = [];

            this.arboCurrent.forEach((element, index) => {
                this.iconData.push({
                    color: element.iconcolor,
                    icon: element.icon,
                    index: index
                });
            });
            console.log("icon", this.iconData);
        },
        pinClick: function(index) {
            this.firstLevel = false;
            this.arboParents.push(this.arboCurrent[index]);
            this.colorButton = this.arboCurrent[index].iconcolor;
            this.arboCurrent = this.arboCurrent[index].children;
            this.changePin();
            this.changeIcon();
        }
    }
};
</script>
<style scoped>
.center {
    margin-bottom: 0rem;
    margin-top: 1rem;
    margin-left: 0.5rem;
}
.centerTitle {
    margin-bottom: 0rem;
    margin-top: 0.5rem;
    margin-left: 0.5rem;
}
.imageParent {
    width: 50px;
    height: 50px;
}
.size {
    width: "50%";
}
.cover {
    margin: 0;
    padding: 0;
    background: url(/img/image.jpg) no-repeat center fixed;
    -webkit-background-size: cover;
    background-size: cover;
}
</style>
